import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from 'react/redux/store/store';

import { PrivateChatAdminHelperComponent } from 'react/chat/inner/display_pieces/messages/PrivateChatAdminHelperComponent.jsx';
import ChatMessagesComponent from 'react/chat/inner/display_pieces/messages/ChatMessagesComponent';
import { StateMessagesComponent } from 'react/chat/inner/display_pieces/messages/StateMessagesComponent.jsx';
import { MatchMutedComponent } from 'react/chat/inner/display_pieces/messages/MatchMutedComponent.jsx';
import ChatLoadingBar from 'react/chat/inner/display_pieces/loading/ChatLoadingBar';
import { JqueryClassFaker } from '../../../../components/JqueryClassFaker';

import { ChatMessages } from 'models/ChatMessages';

export default class ChatHolderComponent extends Component {
	static defaultProps = {
		showChatEmptyBanner: true
	};

	constructor(props) {
		super(props);

		this.chatContainerReference = React.createRef();

		/**
		 * 1 bottom page
		 * scroll up goes toward infinity
		 */
		this.state = {
			lockedToBottom: true,
			currentPage: 1,
			chatMessageCount: props.chatMessages.messages.size,
			messagesPerPage: 60
		};

		this.messagesPerPage = 60;

		this.onChatContainerScroll = this.chatContainerScroll.bind(this);
		this.onScrollCheck = this.scrollCheck.bind(this);
		this.onScrollToBottom = this.scrollToBottom.bind(this);


		this.onHasNewMessagesClick = this.hasNewMessagesClick.bind(this);
	}

	componentDidMount() {
		const { chatMessages } = this.props;
		chatMessages.addScrollingChatHolderComponent(this);
		this.scrollToBottomOnResize = () => {
			if(this.chatContainerReference.current) {
				const height = this.chatContainerReference.current.clientHeight;
				const estimatedMessageHeight = 12;
				let estimatedFittedMessages = Number.parseInt((height ? height : 600) / estimatedMessageHeight) + (15);
				estimatedFittedMessages = 70;

				this.setState({
					messagesPerPage: estimatedFittedMessages
				});
			}
			this.scrollToBottom();

		};
		$(window).on('resize', this.scrollToBottomOnResize);
		this.scrollToBottom();
		this.scrollToFocusedMessage();
	}

	componentWillUnmount() {
		const { chatMessages } = this.props;
		chatMessages.removeScrollingChatHolderComponent(this);
		$(window).off('resize', this.scrollToBottomOnResize);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.chatMessages !== this.props.chatMessages) {
			// Reused for another conversation (e.g. switching DMs): follow the new one's updates.
			prevProps.chatMessages.removeScrollingChatHolderComponent(this);
			this.props.chatMessages.addScrollingChatHolderComponent(this);
		}
		if(snapshot) {


			if(!this.chatContainerReference.current) {
				// console.log('has no reference');
				return;
			}
			if(snapshot.definitelyScrollToBottom || this.props.chatMessages.scrollToBottomOnce) {
				this.props.chatMessages.scrollToBottomOnce = false;
				if(this.props.chatMessages.scrollToBottomOnce) {
					// console.log('scrol to bottom once');
				}
				else {
					// console.log('definitely scroll to bottom!');
				}
				this.scrollToBottom();
			}
			else if(snapshot.keepThisScrollPosition) {
				const list = this.chatContainerReference.current;
				list.scrollTop = list.scrollHeight - snapshot.keepThisScrollPosition;
			}
			else if(snapshot.messageCountChanged) {
				this.scrollToBottom();
			}
		}
		// this._couldScrollUpAPage();
		this.scrollToFocusedMessage();
	}

	// A message opened from a mention (ChatMessages.focusMessage): render back
	// far enough to include it, then scroll it into view, once.
	scrollToFocusedMessage() {
		const { chatMessages } = this.props;
		if(!chatMessages.scrollToFocusedMessage || !this.chatContainerReference.current) {
			return;
		}
		const ids = Array.from(chatMessages.messages.keys());
		const fromBottom = ids.length - ids.indexOf(chatMessages.focusedMessageId);
		const neededPage = Math.ceil(fromBottom / this.state.messagesPerPage);
		if(neededPage > this.state.currentPage) {
			this.setState({ currentPage: neededPage, lockedToBottom: false });
			return;
		}
		const element = this.chatContainerReference.current.querySelector(`[data-id="${chatMessages.focusedMessageId}"]`);
		if(!element) {
			return;
		}
		chatMessages.scrollToFocusedMessage = false;
		element.scrollIntoView({ block: 'center' });
		if(this.state.lockedToBottom) {
			this.setState({ lockedToBottom: false });
		}
	}

	hasNewMessagesClick() {
		this.scrollToBottom();
		this.forceUpdate();
	}

	getSnapshotBeforeUpdate(prevProps, prevState) {
		const snapshot = {};
		let stateChanged = false;
		if(this.state.lockedToBottom &&
			this.isScrolledDistanceFromBottom(this.chatContainerReference.current, ChatHolderComponent.BOTTOM_LOCK_DISTANCE + 50) || this.props.chatMessages.messages.size == 0) {
			stateChanged = true;
			// this.setState({
			// 	chatMessageCount: this.props.chatMessages.messages.size
			// });
			// console.log('message count changed');
			snapshot.messageCountChanged = true;
			// if(prevState.chatMessageCount === 0)
			// {
			snapshot.definitelyScrollToBottom = true;
			// }
		}
		if(this.props.chatMessages.keepScrollPosition) {
			stateChanged = true;
			const list = this.chatContainerReference.current;
			const scrollPosition = list.scrollHeight - list.scrollTop;
			this.props.chatMessages.keepScrollPosition = false;
			snapshot.keepThisScrollPosition = scrollPosition;
		}
		return stateChanged ? snapshot : null;
	}

	scrollCheck() {
		if(!this.chatContainerReference.current) {
			return;
		}
		// if(this.state.lockedToBottom || this.props.chatMessages.scrollToBottomOnce)
		// {
		// 	this.props.chatMessages.scrollToBottomOnce = false;
		// 	this.scrollToBottom();
		// }
	}

	scrollToBottom() {
		if(this.state.currentPage != 1) {
			this.setState({
				currentPage: 1
			});
		}
		if(this.chatContainerReference.current) {
			this.chatContainerReference.current.scrollTop = this.chatContainerReference.current.scrollHeight;
		}
	}

	getTopViewableMessage() {
		return this.state.messagesPerPage * (this.state.currentPage);
	}

	getBottomViewableMessage() {
		return 0;
	}

	getVisibleMessages() {
		const { chatMessages } = this.props;
		const messages = Array.from(chatMessages.messages);

		if(chatMessages.extraMessagesToInject) {
			for(let message of chatMessages.extraMessagesToInject) {
				messages.push([message.id, message]);
			}
			messages.sort(([_, a], [__, b]) => {
				return ChatMessages.compareMessages(a, b);
			});
		}

		return messages.slice(this.getTopViewableMessage() * -1, this.getBottomViewableMessage() ? this.getBottomViewableMessage() * -1 : undefined);
	}

	isAtBottomPage() {
		return this.state.currentPage === 1;
	}

	_couldScrollUpAPage() {
		const element = this.chatContainerReference.current;
		if(!element) {
			return false;
		}
		if(this.isScrolledDistanceFromTop(element, 80) && this.props.chatMessages.messages.size > this.getTopViewableMessage()) {
			this.props.chatMessages.keepScrollPosition = true;
			console.log('go up a page');
			this.setState({ currentPage: this.state.currentPage + 1 });
			return true;
		}
		return false;
	}

	chatContainerScroll() {
		if(this.chatContainerReference.current && this.props.chatMessages.messages.size) {
			const element = this.chatContainerReference.current;
			if(!this.props.chatMessages.lockedToBottom && this.props.chatMessages.messages.size <= this.getTopViewableMessage() && this.isScrolledDistanceFromTop(element, 0)) {
				this.props.chatMessages.loadPreviousMessages();
				console.log('LOAD MORE');
				return;
			}

			if(this._couldScrollUpAPage()) {

			}
			else if(this.state.currentPage != 1 && this.isScrolledDistanceFromBottom(element, 10)) {
				this.setState({ currentPage: 1 });
			}


			if(this.isAtBottomPage() && this.isScrolledDistanceFromBottom(element, ChatHolderComponent.BOTTOM_LOCK_DISTANCE)) {
				if(!this.state.lockedToBottom) {
					// console.log('locking');
					this.props.chatMessages.markAllRead();
					this.props.chatMessages.lockedToBottom = true;
					this.setState({
						lockedToBottom: true
					});
				}
			}
			else {
				if(this.state.lockedToBottom) {
					this.props.chatMessages.lockedToBottom = false;
					this.setState({
						lockedToBottom: false
					});
				}
			}
		}
	}

	isScrolledDistanceFromTop(element, distance) {
		return element.scrollTop <= distance;
	}

	isScrolledDistanceFromBottom(element, distance) {
		return element.scrollTop >= element.scrollHeight - element.offsetHeight - distance;
	}

	render() {
		// console.error('rendering entire chat holder');
		const { chatMessages, isDisabled, isDisabledMessage, showChatEmptyBanner } = this.props;

		chatMessages.setChatContainerReference(this.chatContainerReference);

		let chatContainerClasses = new JqueryClassFaker();
		chatContainerClasses.add('chat_container');
		if(chatMessages.player || chatMessages.match) {
			chatContainerClasses.add('private');
		}
		if(this.props.compact) {
			chatContainerClasses.add('chat_container--compact');
		}
		chatContainerClasses = chatContainerClasses.toString();

		return (
			<div className='chat_container_outer_holder has_rpg'>
				<ChatLoadingBar
					isLoading={chatMessages.isLoadingFirstMessages || !!chatMessages.loadingPreviousMessages}
				/>

				<div
					className={chatContainerClasses}
					onScroll={this.onChatContainerScroll}
					ref={this.chatContainerReference}
				>
					<PrivateChatAdminHelperComponent player={chatMessages.player} />
					<Provider store={store}>
						<ChatMessagesComponent
							completedInitialLoad={chatMessages.completedInitialLoad || chatMessages.match}
							initialLoadFailed={chatMessages.initialLoadFailed}
							scrollCheck={this.onScrollCheck}
							scrollToBottom={this.onScrollToBottom}
							chatMessages={chatMessages}
							isEditing={chatMessages.currentlyEditingMessage}
							visibleMessages={this.getVisibleMessages()}
							showChatEmptyBanner={showChatEmptyBanner}
						/>
					</Provider>
				</div>
				<MatchMutedComponent chatMessages={chatMessages} />
				{isDisabled &&
				<div className='chat_closed'>
					<div className='banner'>{isDisabledMessage || 'Chat Is Closed!'}</div>
				</div>
				}
				<StateMessagesComponent
					stateMessages={chatMessages.stateMessages}
				/>
				{!this.state.lockedToBottom && chatMessages.hasUnreadMessages() &&
				<div onClick={this.onHasNewMessagesClick} className='unseen_messages_popup'>Has New Messages!</div>
				}
			</div>
		);

	}


}

ChatHolderComponent.BOTTOM_LOCK_DISTANCE = 1;